import React from 'react';
// import { loadReCaptcha, ReCaptcha } from 'react-recaptcha-v3'
import ReCAPTCHA from "react-google-recaptcha";
import './uber2.css';
import UberLogo from '../uber-assets/UE_Logo_Horizontal_RGB_web_UE_Logo_Horizontal_RGB_Salt Green.svg';
import { AREAS, AREA_IDS } from './model/areas';
import ApiController from './controller/ApiController';

/**
 * @author Carl Trelfa
 */
const RECAPTCHA_STATE = {
    LOADING: 'loading',
    READY: 'ready',
    VERIFIED: 'verified',
}

const FORM_STATE  = {
    INITIAL: 'initial',
    SUBMITTING: 'submitting',
    SUBMITTED: 'submitted',
}

// const CAPTCHA_VERIFY_URL = 'https://clients.kokodigital.co.uk/ubereats/verifycaptcha/';

export default class NominatePage extends React.Component {
    defaultAreaId = '';

    constructor(props) {
        super(props);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        // console.log('URL Params: ', urlParams, urlParams.get('r'), urlParams.get('l'));

        this.state = {
            reacaptchaState: RECAPTCHA_STATE.LOADING,
            recaptchaToken: null,
            
            fullName: '',
            restaurantName: urlParams.get('r') || '',
            restaurantLocation: 0,
            termsTicked: false,

            fullNameValid: false,
            restaurantNameValid: false,
            showAllErrors: false,

            formState: FORM_STATE.INITIAL,
        }

        this.defaultAreaId = urlParams.get('l') || '';
    }

    
    componentDidMount() {
        if (this.state.restaurantName != '') {
            this.setState({restaurantNameValid: this.validateRestaurantName(this.state.restaurantName)});
        }
        if (this.defaultAreaId !== '') {
            document.getElementById("areaselect").selectedIndex = AREA_IDS.indexOf(this.defaultAreaId);
            this.setState({restaurantLocation: AREA_IDS.indexOf(this.defaultAreaId)});
            this.defaultAreaId = '';
        }
        // loadReCaptcha('6LelWq0eAAAAAH8moHIUDfOM_pPAZpqVp4N00mov', () => this.setState({reacaptchaState: RECAPTCHA_STATE.READY}));
    }

    /*
    verifyCallback = (recaptchaToken) => {
        // Here you will get the final recaptchaToken!!!  
        console.log(recaptchaToken, "<= your recaptcha token");
        this.setState({reacaptchaState: RECAPTCHA_STATE.VERIFIED});
        // this.updateToken();

        /*
        console.log('[CAPTCHA] Verify...');
        fetch(CAPTCHA_VERIFY_URL + '?token=' + recaptchaToken)
            .then(response => response.json())
            .then(data => {
                if (data.response.code === "200") {
                    console.log('[CAPTCHA] Verified: ', data, this);
                }
            })
            */
    // }

    /*
    updateToken = () => {
        // you will get a new token in verifyCallback
        this.recaptcha.execute();
    }
    */

    captchaOnChange = (value) => {
        // console.log("Captcha value:", value);
        this.setState({reacaptchaState: value === null ? RECAPTCHA_STATE.READY : RECAPTCHA_STATE.VERIFIED, recaptchaToken: value});
    }

    nameUpdated = () => {
        let name = window.document.getElementById('fullname').value;
        this.setState({fullName: name});
        this.validateName(name);
    }

    validateName = (nameInput = null) => {
        let name = nameInput || this.state.fullName;
        let nameValid = name.length >= 3;
        this.setState({fullNameValid: nameValid});
        return nameValid;
    }

    restaurantNameUpdated = () => {
        let name = window.document.getElementById('restaurantname').value;
        this.setState({restaurantName: name});
        this.validateRestaurantName(name);
    }

    validateRestaurantName = (nameInput = null) => {
        let name = nameInput || this.state.restaurantName;
        let nameValid = name.length >= 3;
        this.setState({restaurantNameValid: nameValid});
        // console.log('Name updated: ', nameValid, name, encodeURIComponent(name));
        return nameValid;
    }

    validateTermsCheck = () => {
        let termsChecked = document.getElementById('termscheck').checked;
        this.setState({termsTicked: termsChecked});
        return termsChecked;
    }

    validateForm = () => {
        let formValid = this.validateName() && this.validateRestaurantName() && this.validateTermsCheck();
        this.setState({showAllErrors: true});
        return formValid;
    }

    areaUpdated = () => {
        let area = document.getElementById('areaselect').selectedIndex;
        if (this.state.restaurantLocation !== area) {
            this.setState({restaurantLocation: area});
        }
    }

    submitForm = () => {
        if (this.validateForm() && this.state.reacaptchaState === RECAPTCHA_STATE.VERIFIED) {
            // this.updateToken();
            console.log('Submitting form...');
            this.setState({formState: FORM_STATE.SUBMITTING});
            // setTimeout(this.formSubmitted, 1000);
            ApiController.PostNomination(this.state.fullName, this.state.restaurantName, this.state.restaurantLocation, this.state.recaptchaToken, this.formSubmitted);
        } else {
            console.log('Form invalid, not submitted...');
        }
    }

    formSubmitted = () => {
        this.setState({formState: FORM_STATE.SUBMITTED});
    }
    
    render() {
        return (
            <div className="split-page-holder">
                <div className="page-split-left"><div className="left-content-holder">
                    <div className="nom-header">
                        <img className="uber-eats-logo" src='./uber-assets/UE_Logo_Horizontal_RGB_web_GreenBG.svg' />
                    </div>
                    {this.state.formState !== FORM_STATE.SUBMITTED &&
                    <>
                    
                    <h2>It’s back! Uber Eats presents<br />The Restaurant of the Year awards 2023</h2>
                    {/* <h1>Nominate your favourite<br/>restaurant below!</h1> */}
                    
                    {/* <p>The inaugural Uber Eats UK &amp; Ireland Restaurant of the Year awards are here and we need your help to find the Restaurant of the Year, who'll win an incredible £100,000.</p>
                    <p>Regional winners will be invited to the awards ceremony in central London where celebrity restaurateur Dame Prue Leith will announce the winner. Send in your nomination below.</p> */}

                    <p>Following the success of last year’s Uber Eats UK & Ireland Restaurant of the Year awards, we’re back and looking for the best restaurants in 2023. We need your help to find them. The winning restaurant will receive £100,000 and all runners up will be offered a cash prize to help grow their business, alongside a marketing support package from Uber Eats.</p>
                    <p>Shortlisted restaurants will be entered into regional heats, before the final judging day takes place later this year, with a line up including Prue Leith, Monica Galetti, Seema Pankhania and Lorraine Copes.</p>
                    <p>Nominate your favourite restaurant below for them to be in with a chance of winning!</p>

                    
                    <form>
                        <p className="form-label">Full name</p>
                        <input className={this.state.fullNameValid === false && (this.state.fullName !== '' || this.state.showAllErrors) ? 'field-error' : ''} type="text" id="fullname" name="fullname" value={this.state.fullName} onChange={this.nameUpdated} disabled={this.state.formState !== FORM_STATE.INITIAL} />
                        {this.state.fullNameValid === false && (this.state.fullName !== '' || this.state.showAllErrors) &&
                            <p className="error-text">* Your name must be at least 3 letters long</p>
                        }
                        <p className="form-label">Name of restaurant</p>
                        <input className={this.state.restaurantNameValid === false && (this.state.restaurantName !== '' || this.state.showAllErrors) ? 'field-error' : ''} type="text" id="restaurantname" name="restaurantname" value={this.state.restaurantName} onChange={this.restaurantNameUpdated} disabled={this.state.formState !== FORM_STATE.INITIAL} />
                        {this.state.restaurantNameValid === false && (this.state.restaurantName !== '' || this.state.showAllErrors) &&
                            <p className="error-text">* Your restaurant name must be at least 3 letters long</p>
                        }
                        <p className="form-label">Restaurant location</p>
                        <div className="select-holder">
                            <select id="areaselect" onChange={this.areaUpdated} disabled={this.state.formState !== FORM_STATE.INITIAL}>
                            {
                                AREAS.map(
                                    (v, i) => <option key={i} value={AREA_IDS[i]}>{v}</option>
                                )
                            }
                            </select>
                        </div>
                        <div className="flex-columns">
                            <div className="shrink flex-rows">
                                <div className="grow"></div>
                                <div className="shrink">
                                    <input type="checkbox" id="termscheck" name="termscheck" value="terms_checked" onClick={this.validateTermsCheck} disabled={this.state.formState !== FORM_STATE.INITIAL}></input>
                                </div>
                                <div className="grow"></div>
                                <div className="grow"></div>
                            </div>
                            <div className="grow">
                                <p className="form-label">I acknowledge that participation in the Restaurant of the Year Awards is subject to the <a href="https://www.uber.com/en-GB/newsroom/uber-eats-restaurant-awards-terms-and-conditions/" target="_blank">Terms and Conditions</a>.</p>
                            </div>
                        </div>
                        {this.state.termsTicked === false && this.state.showAllErrors &&
                            <p className="error-text">* Please confirm that you agree to our Terms and Conditions</p>
                        }
                        {/*this.state.reacaptchaState !== RECAPTCHA_STATE.LOADING && 
                        <ReCaptcha 
                            ref={ref => this.recaptcha = ref}
                            sitekey="6LelWq0eAAAAAH8moHIUDfOM_pPAZpqVp4N00mov"
                            action='verify'
                            verifyCallback={this.verifyCallback}
                        />
                        */}
                        {// this.state.reacaptchaState !== RECAPTCHA_STATE.VERIFIED &&
                        <ReCAPTCHA
                            sitekey="6Lcbx7AeAAAAAG_Me-BDJNdzs7tWXw_PINyUqG8Q"
                            onChange={this.captchaOnChange}
                        />
                        }
                        {this.state.reacaptchaState !== RECAPTCHA_STATE.VERIFIED && this.state.showAllErrors &&
                            <p className="error-text">* Please complete the captcha</p>
                        }
                        <div className="flex-columns">
                            <div className="shrink">
                                {this.state.formState === FORM_STATE.INITIAL &&
                                    <div className={'form-button' + (this.state.reacaptchaState === RECAPTCHA_STATE.VERIFIED && this.state.fullNameValid && this.state.restaurantNameValid && this.state.termsTicked ? '' : ' disabled')} onClick={this.submitForm}>Submit</div>
                                }
                                {this.state.formState === FORM_STATE.SUBMITTING &&
                                    <div className='form-button disabled'>Submitting Nomination</div>
                                }
                            </div>
                            <div className="grow"></div>
                        </div>
                        <p className="form-label">This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.</p>
                        <p className="form-label">All submitted data will be treated in accordance with our <a href="https://uber.com/legal" target="_blank">Privacy Policy</a>.</p>
                        <p className="form-label">&#169; 2023 Uber Technologies Inc.</p>
                    </form>
                    </>
                    }
                    {this.state.formState === FORM_STATE.SUBMITTED &&
                    <div className='flex-rows'>
                        <div className='shrink'>
                            <h2>Thanks for your nomination</h2>
                            <p>Thanks for submitting your nomination for the Uber Eats UK &amp; Ireland Restaurant of the Year awards 2023. Stay tuned to find out the shortlist for each region.</p>
                        </div>
                        {/* <div className="grow"></div> */}
                        {/* <div className='shrink'>
                            <p className="form-label">Full name</p>
                            <p>{this.state.fullName}</p>
                            <p className="form-label">Name of restaurant</p>
                            <p>{this.state.restaurantName}</p>
                            <p className="form-label">Restaurant location</p>
                            <p>{AREAS[this.state.restaurantLocation]}</p>
                        </div> */}
                        {/* <div className="grow"></div> */}
                        <div className='shrink'>
                            <p className="form-label">This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.</p>
                            <p className="form-label">All submitted data will be treated in accordance with our <a href="https://uber.com/legal" target="_blank">Privacy Policy</a>.</p>
                            <p className="form-label">&#169; 2023 Uber Technologies Inc.</p>
                        </div>
                    </div>
                    }
                </div></div>
                
            </div>
        )
    }
}